import { render, staticRenderFns } from "./EditCalendarCategoryDialog.vue?vue&type=template&id=328821be"
import script from "./EditCalendarCategoryDialog.vue?vue&type=script&lang=js"
export * from "./EditCalendarCategoryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports